export default [{
  name: 'APP_LOGIN_SUCCESS',
  callback: function (e) {
    this.$router.push({
      path: 'dashboard'
    });
  }
},
{
  name: 'APP_LOGOUT',
  callback: function (e) {
    this.$store.dispatch('setSnackbar', {
      show: true,
      color: 'green',
      text: 'Logout successfully.'
    });
    window.axios.post('auth/logout').then(response => {
      
      this.$store.commit('survey/resetSurveys');
      this.$store.commit('resetClients');
      this.$store.commit('round/resetRounds');
      this.$store.commit('question/resetQuestions');
      this.$store.commit('resetContacts');
      this.$store.commit('logout');

      delete window.axios.defaults.headers.common['Authorization'];
      this.$router.push('/login');
      this.$store.dispatch('setLoading', false);
    });
  }
},
{
  name: 'APP_INCORRECT_LOGIN',
  callback: function (e) {
    this.$store.dispatch('setSnackbar', {
      show: true,
      color: 'red',
      text: e
    });
  }
},
{
  name: 'APP_PAGE_LOADED',
  callback: function (e) {}
},
{
  name: 'APP_AUTH_FAILED',
  callback: function (e) {
    this.$store.dispatch('setSnackbar', {
      show: true,
      color: 'error',
      text: 'Session has expired.'
    });
    this.$store.commit('logout');
    this.$router.push('/login');
    delete window.axios.defaults.headers.common['Authorization'];
    this.$store.dispatch('setLoading', false);
  }
},
{
  name: 'APP_BAD_REQUEST',
  // @error api response data
  callback: function (msg) {
    this.$message.error(msg);
  }
},
{
  name: 'APP_ACCESS_DENIED',
  // @error api response data
  callback: function (msg) {
    this.$message.error(msg);
    this.$router.push('/forbidden');
  }
},
{
  name: 'APP_RESOURCE_DELETED',
  // @error api response data
  callback: function (msg) {
    this.$message.success(msg);
  }
},
{
  name: 'APP_RESOURCE_UPDATED',
  // @error api response data
  callback: function (msg) {
    this.$message.success(msg);
  }
},
{
  name: 'APP_VALIDATIONS_ERRORS',
  callback: function (msg) {
    this.$store.dispatch('setSnackbar', {
      show: true,
      color: 'red',
      text: msg
    });
  }
},
{
  name: 'APP_SHOW_MESSAGE_ERROR',
  callback: function (message) {
    this.$store.dispatch('setSnackbar', {
      show: true,
      color: 'red',
      text: message
    });
  }
}
];
// ns1.ifastnet11.org
// ns2.ifastnet11.org



// WEBPACK FOOTER //
// ./src/event.js